// import React,{ useState,useEffect } from 'react';
import React,{ useState,useEffect,useRef } from 'react';
import MenuSelectProductType from './MenuSelectProduct';
import MenuProductView from './MenuProductView';
import MenuPositions from './MenuPosition';
import AnimationBtn from './AnimationBtn';
import MenuFeatures from './MenuFeatures';
import MenuColors from './MenuColors';
import Howtousenew from './Howtousenew';
import HowToUse from './HowToUse';
import FooterControl from './FooterControl';
import FooterControlMob from './FooterControlMob';
import Hidden from '@material-ui/core/Hidden';
import Button from '@material-ui/core/Button';

// import MenuBtn from './MenuBtn';
// import { MicNone } from '@material-ui/icons';
var mob = (navigator.userAgent.indexOf("iPhone") != -1) || ((navigator.userAgent.indexOf("Android") != -1) || (navigator.userAgent.indexOf("Mobile") != -1)) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15");
var mobPortrait = (mob && window.innerHeight > window.innerWidth);
var moblandscap = (mob && window.innerWidth > window.innerHeight);
var isipad = navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1);

export const userContext = React.createContext();
var prevCounter = 0;
var nextClicked = false;
var prevClicked = false;
var buttonSeq = ['onResetMode','onOverviewClick','onTopClick','onSideClick','onBackClick','onZoomKey','onKeyBacklite','onKeysClick','onCloseClick'];
var buttonSeq180 = ['onResetMode','onOverviewClick','onTopClick','onSideClick','onBackClick','onZoomKey',,'onKeyBacklite','onKeysClick','onCloseClick'];


var position = {
   'currentPos': 'reset',
   'close': 0,
   'nintyDegree': 1.04167,
   'reset': 2.08333,
   'top': 1.583,
   'tent': 3.125,
   'theatre': 4.1667,
   'tablet': 5.208,
}

const MainMenu = (props) => {
   const [expandedPanel,setExpandedPanel] = useState(false);
   const [displayed,setDisplayed] = useState(false);
   const [hidden,setHidden] = useState(true);
   const [zoomImg,setZoomImg] = useState('./img/zoomkey.png');
   const [backlitImg,setBacklitImg] = useState('./img/keyboardbacklight.png');
   const [keysImg,setKeysImg] = useState('./img/multidevice.png');
   const [ultraImg,setUltraImg] = useState('./img/ultraquiet.png');

   const [laptop360FrontImg,setLaptop360FrontImg] = useState("./img/back.png");
   const [laptop360KeysImg,setLaptop360KeysImg] = useState("./img/keys360 _1.png")
   const [laptop360TopImg,setLaptop360TopImg] = useState("./img/top.png");
   const [laptop360LeftImg,setLaptop360LefttImg] = useState("./img/overview.png");
   const [laptop360RightImg,setLaptop360RightImg] = useState("./img/side.png");
   const [ecoImg,setEcoImg] = useState("./img/pos_4_1.png");
   const [counter,setCounter] = useState(0);
   const [selectedButton,setSelectedButton] = useState('onResetMode');

   //   const [orientationPotrait, setOrientation] = useState(true);
   //   window.checkOrientationStatus = (orientationStatus) => 
   //   {
   //   //  alert(window.screen.orientation.type);
   //     setOrientation(orientationStatus);
   //  }

   const handleAccordionChange = (panel) => (event,isExpanded) => {
      console.log({ event,isExpanded });
      //setExpandedPanel(isExpanded ? panel  : false );
      if (isExpanded) {
         setExpandedPanel(panel);
         //console.log("shubham");
      } else {
         //  console.log("Pawar");
         setExpandedPanel(false)
      };
      // resetBacklitCloseImg();

   };
   const [camData,setCamData] = useState("");
   var animationSwitch = window.localStorage.getItem('Animation');
   var animTime = 1;
   var animTimes = 1;

   const getData = () => {
      fetch('./model_gl/config.json')
         .then(function (response) {
            return response.json();
         })
         .then(function (myJson) {
            // console.log(myJson.positions);
            setCamData(myJson.positions);
         });
   }
   useEffect(() => {
      getData();
      animationSwitch = window.localStorage.getItem('Animation');
      moblandscap = (mob && window.innerWidth > window.innerHeight);

      //window.localStorage.setItem('tent', false);
      //window.localStorage.setItem('tablet', false);
      //window.localStorage.setItem('theater', false);
      //window.localStorage.setItem('close', false);
      window.localStorage.setItem("position","reset");

      // document.getElementById('whiteBtn').classList.add('select');
      // window.xmlhttp.open("GET", "locale.json", true);
      // window.xmlhttp.send();
      // alert('moblandscap '+moblandscap )
      return () => {
         return false
      }
   },[]);

   useEffect((event) => {
      if (event) {
         if (event.keyCode === 13) {
            this.click();
         }
      }

      return () => {
         return false
      }
   },[])
   useEffect((event) => {
      if (event) {
         if (event.keyCode === 13) {
            this.click();
         }
      }
      var isipad = navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1);

      let mob = (navigator.userAgent.indexOf("iPhone") != -1) || ((navigator.userAgent.indexOf("Android") != -1) || (navigator.userAgent.indexOf("Mobile") != -1)) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15");

      return () => {
         return false
      }

   })


   //For Animation Switch 
   // console.log('animationSwitch anim', animationSwitch)

   if (animationSwitch == 'on') { animTime = 1000; animTimes = 2000 }
   else { animTime = 1; animTimes = 1 }
   // console.log('animTime', animTime)

   //new camera function
   //new camera function
   const GotoPosInTimeNamedValue = (gotoposname,onComplete,onSample) => {
      // below code is updated in it.  
      // updated code ends here

      var opt = undefined,gp = camData[gotoposname];

      //    console.log(gp)
      if (gp.fovy && window.scene.fovy != gp.fovy)
         opt = { fovy: gp.fovy };
      if (gp.pos.length > 5) {
         if (!opt) opt = {};
         opt.zang = gp.pos[5];
      }
      let increase = 0;
      //console.log('animationSwitch',animationSwitch)
      if (animationSwitch == 'off') {
         gp.time = 1
         // console.log('animationSwitch iffff', gp.time)
      }
      else {
         gp.time = animTime;
         // console.log('animationSwitch elseeee', gp.time)
      }
      if (window.mob || window.isipad) {
         /* if (gotoposname === 'Close_Cam_F158_Close') {
            increase = 20;
         } */
      }
      //console.log('animationSwitch',animationSwitch);
      console.log('gp.time',gp.time);

      if (window.mob || window.isipad) {

         window.scene.gotoPosInTime(gp.pos[0],gp.pos[1],gp.pos[2],gp.pos[3],gp.pos[4] + 18,gp.time,onComplete,onSample,opt);
      } else {
         window.scene.gotoPosInTime(gp.pos[0],gp.pos[1],gp.pos[2],gp.pos[3],gp.pos[4],gp.time,onComplete,onSample,opt);
      }


      // console.log(gp.pos[0], gp.pos[1], gp.pos[2], gp.pos[3], gp.pos[4], gp.time, onComplete, onSample, opt);
   }
   //end
   const slowInOut = (x) => {
      var a = 2.1;
      var x2 = 1.0 - x;
      var px = Math.pow(x,a);
      var px2 = Math.pow(x2,a);

      return px / (px + px2);
   }

   const resetBacklitCloseImg = () => {
      setOpenCloseOnOff(false);
      setOpenClose("./img/zoomkey.png");
      setBackliteOnOff(false);
      setBacklite("./img/keyboardbacklight.png");

      // window.scene.materialReplace('LED_Backlit_ON_env', 'LED_Backlit_OFF_env');
      window.scene.clearRefine();

   }

   const clearBluetoothIndicator = useRef(null);
   const clearBluetoothSettimeFirst = useRef(null);
   const clearBluetoothSettimeSecond = useRef(null);
   const clearBluetoothSettimeThird = useRef(null);
   const clearBluetoothSetintervalOne = useRef(null);
   const clearBluetoothSetintervalTwo = useRef(null);
   const clearBluetoothMainInterval = useRef(null);

   const bluetoothIndicator = (stateName) => {
      clearBluetoothIndicator.current = setTimeout(() => {
         console.log('blink');

         window.scene.groupApplyState(stateName);
      },500);
      // window.localStorage.setItem('hotspot','keys');
      window.scene.groupApplyState('LED_OFF');
      window.scene.clearRefine();
   }

   const bluetoothBlikingLoop = () => {
      //  window.hotspot = "multidevice";
      clearBluetoothSettimeFirst.current = setTimeout(() => {


         // window.scene.animPlayAllChildrenInTime("keys.002",0.0416667,500,function () {
         //    console.log("upp3")
         // },undefined,undefined,true,0.4160000,0);
         // window.scene.clearRefine();
         // console.log("led 1 on")

         clearTimeout(clearBluetoothSettimeThird.current);


         window.scene.groupApplyState('all_led_off');
         setTimeout(() => {
            window.scene.groupApplyState('led_01_on');

            window.scene.animPlayAllChildrenInTime("Keys.002",0.2083333,500,function () {

            },undefined,undefined,true,0.4160000,0);
            window.scene.animPlayAllChildrenInTime("Keys.002",0.4160000,500,function () {

            },undefined,undefined,true,0.2083333,0);
            window.scene.clearRefine();

            // window.localStorage.setItem('currentBluetooth','bluetooth1');
            window.bluetooth = "bluetooth1";
         },100);

         // window.scene.animPlayAllChildrenInTime("keys.002",0.41,500,function () {
         //    console.log("upp1")
         // },undefined,undefined,true,0.2083333,0);


         // console.log("led 1 on")

         /* clearBluetoothSetintervalOne.current = setInterval(() => {
            bluetoothIndicator('LED_01_ON');
         },1000) */
         clearBluetoothSettimeSecond.current = setTimeout(() => {
            clearTimeout(clearBluetoothSettimeFirst.current);
            clearInterval(clearBluetoothSetintervalOne.current);
            clearTimeout(clearBluetoothIndicator.current);

            setTimeout(() => {
               window.scene.groupApplyState('led_01_off');
               window.scene.groupApplyState('led_02_on');

               window.scene.animPlayAllChildrenInTime("Keys.002",0.2083333,500,function () {

               },undefined,undefined,true,0.4160000,0);
               window.scene.animPlayAllChildrenInTime("Keys.002",0.4160000,500,function () {

               },undefined,undefined,true,0.2083333,0);
               window.scene.clearRefine();

               // window.localStorage.setItem('currentBluetooth','bluetooth2');
               window.bluetooth = "bluetooth2";
            },100);
            // window.scene.animPlayAllChildrenInTime("keys.002",0.8333333,500,function () {
            //    console.log("upp2")
            // },undefined,undefined,true,0.6250000,0);
            console.log("led 2 on")

            /* clearBluetoothSetintervalTwo.current = setInterval(() => {
               bluetoothIndicator('LED_02_ON');
            },1000) */
            clearBluetoothSettimeThird.current = setTimeout(() => {

               clearTimeout(clearBluetoothSettimeSecond.current);
               clearTimeout(clearBluetoothSetintervalTwo.current);
               clearInterval(clearBluetoothIndicator.current);


               setTimeout(() => {
                  window.scene.groupApplyState('led_01_off');
                  window.scene.groupApplyState('led_02_off');
                  window.scene.groupApplyState('led_03_on');

                  window.scene.animPlayAllChildrenInTime("Keys.002",0.2083333,500,function () {

                  },undefined,undefined,true,0.4160000,0);
                  window.scene.animPlayAllChildrenInTime("Keys.002",0.4160000,500,function () {

                  },undefined,undefined,true,0.2083333,0);
                  window.scene.clearRefine();

                  // window.localStorage.setItem('currentBluetooth','bluetooth3');
                  window.bluetooth = "bluetooth3";
               },100);
               // window.scene.animPlayAllChildrenInTime("keys.002",1.2500000,500,function () {
               //    console.log("upp3")
               // },undefined,undefined,true,1.0416666,0);
               console.log("led 3 on")
            },2000)
         },2000)
      },500)
   }

   const clearAllBluetoothSetTime = () => {

      console.log('clearAllBluetoothSetTime');
      clearTimeout(clearBluetoothMainInterval.current);
      clearTimeout(clearBluetoothSettimeFirst.current);
      clearTimeout(clearBluetoothSettimeSecond.current);
      clearTimeout(clearBluetoothSettimeThird.current);
      clearTimeout(clearBluetoothIndicator.current);
      clearInterval(clearBluetoothSetintervalOne.current);
      clearInterval(clearBluetoothSetintervalTwo.current);
      window.scene.groupApplyState('all_led_off');
   }


   useEffect(() => {
      window.addEventListener('mousedown',(e) => {
         if (window.keysCam != false) {
            console.log(window.keysCam);
            clearAllBluetoothSetTime();
         }
      })
      window.addEventListener('wheel',(e) => {
         console.log("in wheel");
         //if (window.keysCam != false) {
         clearAllBluetoothSetTime();
         //  }
      })
      // window.addEventListener('DOMMouseScroll',(e) => {
      //    console.log("in DOMMouseScroll");
      //    if (window.keysCam != false) {
      //       clearAllBluetoothSetTime();
      //    }
      // })
      return () => {
         window.removeEventListener('mousedown',clearAllBluetoothSetTime(),false);
         window.removeEventListener('wheel',clearAllBluetoothSetTime(),false);
         // window.removeEventListener('DOMMouseScroll',clearAllBluetoothSetTime(),false);
      }
   },[])

   useEffect(() => {
      return () => {
         // window.localStorage.setItem('hotspot','keys');
         console.log('clear led interval');
         clearAllBluetoothSetTime();
      }
   },[window.keysCam])

   const clearTimeOutZoomKeyOne = useRef(null);
   const clearTimeOutZoomKeyTwo = useRef(null);
   const clearTimeOutZoomKeyThree = useRef(null);
   const clearTimeOutZoomKeyFour = useRef(null);
   const clearTimeOutZoomKeyFifth = useRef(null);

   const clearAllZoomKeySetTime = () => {
      console.log('clearAllZoomKeySetTime')
      clearTimeout(clearTimeOutZoomKeyOne.current);
      clearTimeout(clearTimeOutZoomKeyTwo.current);
      clearTimeout(clearTimeOutZoomKeyThree.current);
      clearTimeout(clearTimeOutZoomKeyFour.current);
      clearTimeout(clearTimeOutZoomKeyFifth.current);
      window.scene.groupApplyState('ALL_ICONS_ON');
   }

   useEffect(() => {

      window.addEventListener('mousedown',(e) => {
         if (window.zoomCam != false) {
            console.log(window.zoomCam);
            clearAllZoomKeySetTime();
         }
      })
      window.addEventListener('wheel',(e) => {
         console.log("in wheel");
         clearAllZoomKeySetTime();
      })
      return () => {
         window.removeEventListener('mousedown',clearAllZoomKeySetTime,false);
         window.removeEventListener('wheel',clearAllZoomKeySetTime,false);
      }
   },[])

   /* useEffect(() => {
      return () => {
         console.log('clearAllZoomKeySetTime');
         clearAllZoomKeySetTime();
      }
   },[window.zoomCam]) */

   const resetAll = () => {
      clearAllBluetoothSetTime();
      clearTimeout(clearTimeOutZoomKeyOne.current);
      clearTimeout(clearTimeOutZoomKeyTwo.current);
      clearTimeout(clearTimeOutZoomKeyThree.current);
      clearTimeout(clearTimeOutZoomKeyFour.current);
      clearTimeout(clearTimeOutZoomKeyFifth.current);
      window.scene.groupApplyState("dongle_off");
      window.keysCam = false;
      window.zoomCam = false;
      window.backlightCam = false;
      window.UniqDeltaScroll = false;
      window.UniqDeltaScroll2 = false;
      window.localStorage.removeItem('currentBluetooth');

      window.scene.groupApplyState("LIGHT_OFF");
      window.scene.groupApplyState("GP_off");
      window.scene.groupApplyState("Dongle_off");
      window.scene.groupApplyState("USB_off");
      window.scene.groupApplyState("Wair_GP_OFF");

      window.scene.groupApplyState('KEYBOARD_GP_OFF');
      window.scene.groupApplyState('KEYBOARD_REF_BOX_OFF');

      window.scene.groupApplyState('WAIR_USB_REF_BOX_OFF');
      window.scene.groupApplyState('WAIR_USB_GP_OFF');


      if (window.scene.animIsPlaying('DE_1662_CA_Trident')) window.scene.getAnim("DE_1662_CA_Trident").stop();
      if (window.scene.animIsPlaying('DE_1662_CA_Trident.001')) window.scene.getAnim("DE_1662_CA_Trident.001").stop();
      if (window.scene.animIsPlaying('hing1')) window.scene.getAnim("hing1").stop();
      if (window.scene.animIsPlaying('hing2')) window.scene.getAnim("hing2").stop();
      if (window.scene.animIsPlaying('hing1.001')) window.scene.getAnim("hing1.001").stop();
      if (window.scene.animIsPlaying('hing2.001')) window.scene.getAnim("hing2.001").stop();

      window.scene.animPlayInTime("hing1",0,0);
      window.scene.animPlayInTime("hing2",0,0);

      window.scene.animPlayInTime("hing1.001",0,0);
      window.scene.animPlayInTime("hing2.001",0,0);

      window.scene._fDoFFarAperture = 4;


      // window.scene.animPlayInTime("DE_1662_CA_Trident",0,0);
      // window.scene.animPlayInTime("DE_1662_CA_Trident.001",0,0);


   }
   const reverseAll = () => {

      window.scene._bDoF = true;

      window.scene._nav.tempfRotMinLimit = 0.48;
      window.scene._nav._navMinDolly = 14;
      // window.scene._nav._navMaxDolly = 27;
      window.scene._nav._navMaxDolly = 27;

      // var hotspotContainer = document.getElementById('hotspot_container');
      // if (hotspotContainer.style.display == "block" || hotspotContainer.style.display == "") {
      //    hotspotContainer.style.display = "none"
      // }


      if (window.innerWidth > window.innerHeight) {
         window.localStorage.removeItem('hotspot');
         window.localStorage.removeItem('currentBluetooth');
      }
      window.hotspot = '';
      window.bluetooth = '';
      window.scene.groupApplyState("key_on");
      window.scene.groupApplyState("keyboard_backlight_off");
      document.getElementById('popupContainer').style.display = 'none';


      // window.scene.animPlayInTime("Mode_Connection_Button",0.041666,0);
      window.scene.clearRefine();

   }
   // const reverAnimation = () => {

   //    if (window.scene.animIsPlaying("CA_Wireless_KB_MPD_Keyboard")) window.scene.getAnim("CA_Wireless_KB_MPD_Keyboard").stop();
   //    if (window.scene.animIsPlaying("CA_Wireless_KB_MPD")) window.scene.getAnim("CA_Wireless_KB_MPD").stop();
   //    if (window.scene.animIsPlaying("CA_Wireless_KB_MPD_REF")) window.scene.getAnim("CA_Wireless_KB_MPD_REF").stop();
   //    if (window.scene.animIsPlaying("STAND_L")) window.scene.getAnim("STAND_L").stop();
   //    if (window.scene.animIsPlaying("Right_foot")) window.scene.getAnim("Right_foot").stop();

   //    window.scene.animPlayInTime("CA_Wireless_KB_MPD_Keyboard",0,0);
   //    window.scene.animPlayInTime("CA_Wireless_KB_MPD",0,0);
   //    window.scene.animPlayInTime("CA_Wireless_KB_MPD_REF",0,0);
   //    window.scene.animPlayInTime("STAND_L",0,0);
   //    window.scene.animPlayInTime("Right_foot",0,0);


   //    window.scene.clearRefine();
   // }

   const resetTimeline1 = (revers90Degree = true) => {
      //window.scene.instanceSet("GP_Close_360", "visible", false);
      //window.scene.instanceSet("GP_Stand", "visible", false);
      //window.scene.instanceSet("GP_Tent", "visible", false);
      //window.scene.instanceSet("GP_Tablet", "visible", false);
      if (window.scene.animIsPlaying('Screen_90_degree')) window.scene.getAnim("Screen_90_degree").stop();
      if (window.scene.animIsPlaying('Screen_grp_timeline_01_A')) window.scene.getAnim("Screen_grp_timeline_01_A").stop();
      if (window.scene.animIsPlaying('Hinge_grp_timeline_01_A')) window.scene.getAnim("Hinge_grp_timeline_01_A").stop();
      if (window.scene.animIsPlaying('Main_grp_timeline_01_A')) window.scene.getAnim("Main_grp_timeline_01_A").stop();

      if (revers90Degree) {
         // window.scene.animPlayInTime("Screen_90_degree", 0, 0);
         // window.scene.animPlayInTime("Screen_90_to_close180", 0, 0);
         // window.scene.animPlayInTime("Screen_90_to_close360", 0, 0);
      }
      window.scene.animPlayInTime("Screen_grp_timeline_01_A",0,0);
      window.scene.animPlayInTime("Hinge_grp_timeline_01_A",0,0);
      window.scene.animPlayInTime("Main_grp_timeline_01_A",0,0);
      window.scene.clearRefine();
   }
   const resetTimeline2 = (revers90Degree = true) => {
      //window.scene.instanceSet("GP_Close_360", "visible", false);
      //window.scene.instanceSet("GP_Stand", "visible", false);
      //window.scene.instanceSet("GP_Tent", "visible", false);
      //window.scene.instanceSet("GP_Tablet", "visible", false);
      if (window.scene.animIsPlaying('Screen_90_degree')) window.scene.getAnim("Screen_90_degree").stop();
      if (window.scene.animIsPlaying('Screen_grp_timeline_02_A')) window.scene.getAnim("Screen_grp_timeline_02_A").stop();
      if (window.scene.animIsPlaying('Hinge_grp_timeline_02_A')) window.scene.getAnim("Hinge_grp_timeline_02_A").stop();
      if (window.scene.animIsPlaying('Main_grp_timeline_02_A')) window.scene.getAnim("Main_grp_timeline_02_A").stop();
      if (revers90Degree) {
         // window.scene.animPlayInTime('Screen_90_degree', 0, 0);
         // window.scene.animPlayInTime('Screen_90_degree_180', 0, 0);

      }
      window.scene.animPlayInTime("Screen_grp_timeline_02_A",0,0);
      window.scene.animPlayInTime("Hinge_grp_timeline_02_A",0,0);
      window.scene.animPlayInTime("Main_grp_timeline_02_A",0,0);
      window.scene.clearRefine();
   }
   const resetTimeline3 = (revers90Degree = true) => {
      //window.scene.instanceSet("GP_Close_360", "visible", false);
      //window.scene.instanceSet("GP_Stand", "visible", false);
      //window.scene.instanceSet("GP_Tent", "visible", false);
      //window.scene.instanceSet("GP_Tablet", "visible", false);
      if (window.scene.animIsPlaying('Screen_90_degree')) window.scene.getAnim("Screen_90_degree").stop();
      if (window.scene.animIsPlaying('Screen_grp_timeline_03_A')) window.scene.getAnim("Screen_grp_timeline_03_A").stop();
      if (window.scene.animIsPlaying('Hinge_grp_timeline_03_A')) window.scene.getAnim("Hinge_grp_timeline_03_A").stop();
      if (window.scene.animIsPlaying('Main_grp_timeline_03_A')) window.scene.getAnim("Main_grp_timeline_03_A").stop();
      if (revers90Degree) {
         // window.scene.animPlayInTime('Screen_90_degree', 0, 0);
         // window.scene.animPlayInTime('Screen_90_degree_180', 0, 0);

      }
      window.scene.animPlayInTime("Screen_grp_timeline_03_A",0,0);
      window.scene.animPlayInTime("Hinge_grp_timeline_03_A",0,0);
      window.scene.animPlayInTime("Main_grp_timeline_03_A",0,0);
      window.scene.clearRefine();
   }
   const resetTimeline4 = (revers90Degree = true) => {
      //window.scene.instanceSet("GP_Close_360", "visible", false);
      //window.scene.instanceSet("GP_Stand", "visible", false);
      //window.scene.instanceSet("GP_Tent", "visible", false);
      //window.scene.instanceSet("GP_Tablet", "visible", false);
      if (window.scene.animIsPlaying('Screen_90_degree')) window.scene.getAnim("Screen_90_degree").stop();
      if (window.scene.animIsPlaying('Main_grp_timeline_04_A')) window.scene.getAnim("Main_grp_timeline_04_A").stop();
      if (window.scene.animIsPlaying('Hinge_grp_timeline_04_A')) window.scene.getAnim("Hinge_grp_timeline_04_A").stop();
      if (window.scene.animIsPlaying('Screen_grp_timeline_04_A')) window.scene.getAnim("Screen_grp_timeline_04_A").stop();
      if (revers90Degree) {
         // window.scene.animPlayInTime('Screen_90_degree', 0, 0);
         // window.scene.animPlayInTime('Screen_90_degree_180', 0, 0);

      }
      window.scene.animPlayInTime("Main_grp_timeline_04_A",0,0);
      window.scene.animPlayInTime("Hinge_grp_timeline_04_A",0,0);
      window.scene.animPlayInTime("Screen_grp_timeline_04_A",0,0);
      window.scene.clearRefine();
   }
   const posClicked1 = () => {
      window.localStorage.removeItem('hotspot');
      window.localStorage.removeItem('currentBluetooth');
      window.localStorage.removeItem('color');
      window.scene.animPlayInTime("Screen_grp_timeline_01",0,animTime);

   }


   //MenuSelectProduct
   const [laptop360,setlaptop360] = useState(true);

   const [laptop180,setlaptop180] = useState(false);

   const laptopClick = (event) => {

      setlaptop180(true);
      setlaptop360(false);
      console.log(laptop180);
      setCounter(0);
      setSelectedButton('onResetMode');
      setValue(event.target.value);
      setDisplayed(true);
      // setExpandedPanel(false);
      setHidden(false);
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');

      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('laptop').setAttribute('aria-label','laptop radio butoon selected');
      window.scene.groupApplyState("screen_180");
      window.scene.groupApplyState("GP_open");
      window.scene.groupApplyState("dynamic_reset");
      window.scene.groupApplyState("screenfill_180");

      setLaptop360FrontImg("./img/front180White.png");
      setLaptop360TopImg("./img/top180White.png");
      setLaptop360LefttImg("./img/180_white_left.png");
      setLaptop360RightImg("./img/180_white_right.png");
      resetBacklitCloseImg();

      window.localStorage.setItem("position","reset");
      window.localStorage.setItem("laptop","laptop180");
      window.localStorage.removeItem('color');

      var radiobtn1 = document.getElementById('twoinoneRadio');
      radiobtn1.checked = false;
      var radioSelector1 = document.querySelector('#twoinoneRadio')
      var nextSibling1 = radioSelector1.nextElementSibling;
      var selectSVG1 = nextSibling1.lastChild;
      selectSVG1.style.transform = 'scale(0)'
      // nextSibling1.classList.remove('PrivateRadioButtonIcon-checked-16')
      var radiobtn2 = document.getElementById('laptopRadio');
      radiobtn2.checked = true;
      var radioSelector2 = document.querySelector('#laptopRadio')
      var nextSibling2 = radioSelector2.nextElementSibling;
      var selectSVG2 = nextSibling2.lastChild;
      selectSVG2.style.transform = 'scale(1)'
      // nextSibling2.classList.add('PrivateRadioButtonIcon-checked-16')
      document.getElementById("laptopRadio").tabIndex = 1;

      window.localStorage.removeItem('hotspot');
      window.localStorage.removeItem('currentBluetooth');
      // document.getElementById('whiteBtn').classList.add('select');
      // document.getElementById('whiteBtn').classList.add('active');

      // var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      //  alreadySelected.classList.remove('active');

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      // document.getElementById('whiteBtn').classList.add('active');
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.select');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('select');
      }
      window.RT_RecordEvent("Product Type","Laptop",window.config.name);
      //add for tab issues
      document.getElementById("hotspot1").setAttribute("tabindex","-1");
      // document.getElementById("tentBtn").setAttribute("tabindex", "-1");
      // document.getElementById("theaterBtn").setAttribute("tabindex", "-1");
      // document.getElementById("tabletBtn").setAttribute("tabindex", "-1");

      document.getElementById("hotspot2").setAttribute("tabindex","-1");
      document.getElementById("hotspot3").setAttribute("tabindex","-1");
      document.getElementById("hotspot4").setAttribute("tabindex","-1");
      document.getElementById("hotspot5").setAttribute("tabindex","-1");
      document.getElementById("hotspot6").setAttribute("tabindex","-1");
      document.getElementById("hotspot7").setAttribute("tabindex","-1");
      document.getElementById("hotspot8").setAttribute("tabindex","-1");
      document.getElementById("hotspot9").setAttribute("tabindex","-1");

      document.getElementById("tentBtn").setAttribute("tabindex","-1");
      document.getElementById("theaterBtn").setAttribute("tabindex","-1");
      document.getElementById("tabletBtn").setAttribute("tabindex","-1");

      //  document.getElementById('laptop2in1').classList.remove('select');
      document.getElementById('laptop').classList.add('active');
      document.getElementById('laptop2in1').classList.remove('active');
      document.getElementById('laptop2in1').classList.remove('select');

      GotoPosInTimeNamedValue('Render_Cam_F01_L',function () {

         window.scene.groupApplyState("Silver_180");
         window.scene.groupApplyState("screenfill_180");
      });

      // document.querySelector('#blackBtn').classList.add('Btnsubmenus');
      // document.querySelector('#blackBtn').classList.remove('Mui-disabled');
      // document.querySelector('#blackBtn').style.pointerEvents = 'auto';
      // document.querySelector('#blackBtn').style.pointerEvents = "auto";
      // document.querySelector('#blackBtn').setAttribute = ("onclick");
      // document.querySelector('#menucolor').setAttribute = ("onBlackBtnClick");


      // document.querySelector('#tentBtn').classList.add('Mui-disabled');
      // document.querySelector('#tentBtn').style.pointerEvents = 'none';
      // document.querySelector('#tentBtn').setAttribute("tabindex", "-1");

      // document.querySelector('#theaterBtn').classList.add('Mui-disabled');
      // document.querySelector('#theaterBtn').style.pointerEvents = 'none';
      // document.querySelector('#theaterBtn').setAttribute("tabindex", "-1");

      // document.querySelector('#tabletBtn').classList.add('Mui-disabled');
      // document.querySelector('#tabletBtn').style.pointerEvents = 'none';
      // document.querySelector('#tabletBtn').setAttribute("tabindex", "-1");
      // document.getElementById("blackBtn").setAttribute("tabindex","1");

      // document.getElementById("tentBtn1").setAttribute("tabindex", "-1");
      // document.getElementById("theaterBtn1").setAttribute("tabindex", "-1");
      // document.getElementById("tabletBtn1").setAttribute("tabindex", "-1");

      if (position.currentPos == 'theatre' || position.currentPos == 'tablet') {
         var currentPosName = position.currentPos;
         if (position.reset == position[currentPosName]) { position.currentPos = 'reset'; return; }
         window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD",position.reset,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
         window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD_Keyboard",position.reset,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
         window.scene.clearRefine();
         position.currentPos = 'reset';
         window.scene.clearRefine();
      } else {
         var currentPosName = position.currentPos;
         if (position.reset == position[currentPosName]) { position.currentPos = 'reset'; return; }
         window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD",position.reset,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
         window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD_Keyboard",position.reset,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
         window.scene.clearRefine();
         position.currentPos = 'reset';
         window.scene.clearRefine();
      }


   }

   const [value,setValue] = useState('2 in 1');

   const select2in1Click = (event) => {
      setlaptop360(true);
      setlaptop180(false);
      console.log(laptop360); setSelectedButton('onResetMode');
      setValue(event.target.value);
      setDisplayed(false);
      setHidden(true);
      // setExpandedPanel(false);
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('laptop2in1').setAttribute('aria-label','2in1 radio butoon selected');
      var alreadySelecte = document.querySelector('.MuiAccordionDetails-root.select');
      if (alreadySelecte != null) {
         alreadySelecte.classList.remove('select');
      }

      // var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      // if(alreadySelected != null){
      //   alreadySelected.classList.remove('active');
      // }
      document.getElementById('laptop2in1').classList.add('active');
      document.getElementById('laptop2in1').classList.add('select');
      // document.getElementById('whiteBtn').classList.add('select');
      // document.getElementById('whiteBtn').classList.add('active');
      document.getElementById('laptop').classList.remove('active');
      document.getElementById('laptop').classList.remove('select');
      document.getElementById("tentBtn").setAttribute("tabindex","1");
      document.getElementById("theaterBtn").setAttribute("tabindex","1");
      document.getElementById("tabletBtn").setAttribute("tabindex","1");

      // document.getElementById("blackBtn").setAttribute("tabindex", "-1");

      window.localStorage.removeItem('hotspot');
      window.localStorage.removeItem('currentBluetooth');
      window.scene.groupApplyState("screen_180");
      window.scene.groupApplyState("GP_open");
      window.localStorage.setItem("position","reset");
      window.scene.groupApplyState("screenfill_360");
      window.scene.groupApplyState("dynamic_reset");

      window.localStorage.setItem("laptop","laptop360");
      window.localStorage.removeItem('hotspot');
      window.localStorage.removeItem('currentBluetooth');

      var radiobtn1 = document.getElementById('laptopRadio');
      radiobtn1.checked = false;
      var radioSelector1 = document.querySelector('#laptopRadio')
      var nextSibling1 = radioSelector1.nextElementSibling;
      var selectSVG1 = nextSibling1.lastChild;
      selectSVG1.style.transform = 'scale(0)'
      var radiobtn2 = document.getElementById('twoinoneRadio');
      radiobtn2.checked = true;
      var radioSelector2 = document.querySelector('#twoinoneRadio')
      var nextSibling2 = radioSelector2.nextElementSibling;
      var selectSVG2 = nextSibling2.lastChild;
      selectSVG2.style.transform = 'scale(1)'

      window.localStorage.removeItem('color');
      document.getElementById("twoinoneRadio").tabIndex = 1;


      window.RT_RecordEvent("Product Type","2 in 1",window.config.name);
      //add for tab issues
      document.getElementById("hotspot1").setAttribute("tabindex","-1");
      document.getElementById("hotspot2").setAttribute("tabindex","-1");
      document.getElementById("hotspot3").setAttribute("tabindex","-1");
      document.getElementById("hotspot4").setAttribute("tabindex","-1");
      document.getElementById("hotspot5").setAttribute("tabindex","-1");
      document.getElementById("hotspot6").setAttribute("tabindex","-1");
      document.getElementById("hotspot7").setAttribute("tabindex","-1");
      document.getElementById("hotspot8").setAttribute("tabindex","-1");
      document.getElementById("hotspot9").setAttribute("tabindex","-1");


      setLaptop360FrontImg("./img/front360.png");
      setLaptop360TopImg("./img/top360.png");
      setLaptop360LefttImg("./img/360_left.png");
      setLaptop360RightImg("./img/360_right.png");

      resetBacklitCloseImg();

      GotoPosInTimeNamedValue('Render_Cam_F01_L',function () {
         window.scene.groupApplyState("Silver");

      });
      // document.querySelector('#blackBtn').classList.add('Mui-disabled');
      // document.querySelector('#blackBtn').style.pointerEvents = "auto";
      // document.querySelector('#blackBtns').classList.remove('Btnsubmenus');

      // document.querySelector('#blackBtn').removeAttribute = ("onclick");

      // document.querySelector('#menucolor').removeAttribute = ("onBlackBtnClick");


      // document.querySelector('#tentBtn').classList.remove('Mui-disabled');
      // document.querySelector('#tentBtn').style.pointerEvents = 'auto';
      // document.querySelector('#tentBtn').setAttribute("tabindex", "1");

      // document.querySelector('#theaterBtn').classList.remove('Mui-disabled');
      // document.querySelector('#theaterBtn').style.pointerEvents = 'auto';
      // document.querySelector('#theaterBtn').setAttribute("tabindex", "1");

      // document.querySelector('#tabletBtn').classList.remove('Mui-disabled');
      // document.querySelector('#tabletBtn').style.pointerEvents = 'auto';
      // document.querySelector('#tabletBtn').setAttribute("tabindex", "1");
      // document.getElementById("blackBtn").setAttribute("tabindex","1");

      // document.getElementById("tentBtn1").setAttribute("tabindex", "1");
      // document.getElementById("theaterBtn1").setAttribute("tabindex", "1");
      // document.getElementById("tabletBtn1").setAttribute("tabindex", "1");

      if (position.currentPos == 'theatre' || position.currentPos == 'tablet') {
         var currentPosName = position.currentPos;
         if (position.reset == position[currentPosName]) { position.currentPos = 'reset'; return; }
         window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD",position.reset,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
         window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD_Keyboard",position.reset,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
         window.scene.clearRefine();
         position.currentPos = 'reset';
         window.scene.clearRefine();
      } else {
         var currentPosName = position.currentPos;
         if (position.reset == position[currentPosName]) { position.currentPos = 'reset'; return; }
         window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD",position.reset,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
         window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD_Keyboard",position.reset,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
         window.scene.clearRefine();
         position.currentPos = 'reset';
         window.scene.clearRefine();
      }

   }

   //MenuProductView

   const onBackClick = (isNextPrevious) => {
      console.log("onBackClick");
      // window.scene._nav._panMax = [16,7];    //[left, bottom];
      // window.scene._nav._panMin = [-12,-7];  //[right, top];
      //Update ZoomBar

      resetAll();
      reverseAll();
      firstTime = true;
      window.ProductView = true;
      window.featuresView = false;
      window.scene._nav._navMinDolly = 13.0; //50 
      var slider = document.getElementById("sliderRange");
      window.scene.groupApplyState("dongle_off");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      console.log(position.nintyDegree,position.currentPos)

      //   var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      //    alreadySelected.classList.remove('active');
      // document.getElementById('frontBtn').classList.add('active');

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('wirelessdesignBtn').classList.add('active');
      window.localStorage.setItem("position","reset");
      // window.scene.groupApplyState("screen_180");
      // window.scene.groupApplyState("GP_open");
      var currentPosName = position.currentPos;

      setSelectedButton('onBackClick');
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Front view');

         document.getElementById('nextView').setAttribute('aria-label','Front view');
      }
      if (laptop180) {
         window.scene.groupApplyState("screenfill_180");
      } else {
         window.scene.groupApplyState("screenfill_360");
      }


      window.localStorage.removeItem('hotspot');
      window.localStorage.removeItem('currentBluetooth');
      window.scene.animPlayInTime("DE_1662_CA_Trident",0,0);
      window.scene.animPlayInTime("DE_1662_CA_Trident.001",0,0);
      window.scene.clearRefine();
      resetBacklitCloseImg();
      window.scene.groupApplyState("Dongle_off");
      window.scene.groupApplyState("keyboard_backlight_off");
      window.scene.groupApplyState("F01_GP_ON");
      window.scene.groupApplyState('KEYBOARD_GPF01_ON');
      window.scene.groupApplyState('KEYBOARD_REF_BOX_ON');
      window.scene.groupApplyState('ALL_ICONS_ON');
      GotoPosInTimeNamedValue('Render_Cam_F01_RL',function () {

         window.localStorage.setItem('hotspot','wirelessdesign');
         window.hotspot = "back";
         // window.scene._nav._fovRecoveryOffset = 2
         if (isNextPrevious != true) {
            // alert("isNextPrevious");
            window.document.getElementById("hotspot1demo").focus();
         }
      })
      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","1");
         document.getElementById("hotspot9").setAttribute("tabindex","1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");
         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("hotspot12").setAttribute("tabindex","-1");
         document.getElementById("hotspot13").setAttribute("tabindex","-1");
         document.getElementById("hotspot14").setAttribute("tabindex","-1");
         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");

      }
      if (position.nintyDegree == position[currentPosName]) { position.currentPos = 'nintyDegree'; return; }
      if (position.currentPos == 'theatre' || position.currentPos == 'tablet') {
         console.log("Theater")
         // window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
         window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD_Keyboard",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
      }
      else {
         console.log("else")
         // window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
         window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD_Keyboard",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
      }

      window.RT_RecordEvent("Product Type","Front",window.config.name);
      window.scene.clearRefine();
      position.currentPos = 'nintyDegree';

   }

   const onKeysClick = (isNextPrevious) => {
      console.log("onKeysClick");

      //Update ZoomBar

      var slider = document.getElementById("sliderRange");
      resetAll();
      reverseAll();
      firstTime = true;
      window.scene._nav._navMaxDolly = 27;
      window.UniqDeltaScroll2 = true;
      window.keysCam = true;
      window.scene.groupApplyState("dongle_off");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      console.log(position.nintyDegree,position.currentPos)

      //   var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      //    alreadySelected.classList.remove('active');
      // document.getElementById('frontBtn').classList.add('active');

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('multidevice').classList.add('active');
      window.localStorage.setItem("position","reset");
      window.scene.groupApplyState("screen_180");
      window.scene.groupApplyState("GP_open");
      window.scene.groupApplyState("REF_KB");
      window.scene.groupApplyState("F01_GP_ON");
      var currentPosName = position.currentPos;


      setSelectedButton('onKeysClick');
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Front view');

         document.getElementById('nextView').setAttribute('aria-label','Front view');
      }
      if (laptop180) {
         window.scene.groupApplyState("screenfill_180");
      } else {
         window.scene.groupApplyState("screenfill_360");
      }


      window.localStorage.removeItem('hotspot');
      window.localStorage.removeItem('currentBluetooth');
      window.scene.animPlayInTime("DE_1662_CA_Trident",0,0);
      window.scene.animPlayInTime("DE_1662_CA_Trident.001",0,0);
      window.scene.clearRefine();
      resetBacklitCloseImg();

      window.scene.groupApplyState("Backlit_OFF");
      window.scene.groupApplyState("keyboard_backlight_off");
      window.scene.groupApplyState("dynamic_reset");
      //window.scene.groupApplyState("GP_All");
      window.scene.groupApplyState("REF_KB");
      window.scene.groupApplyState("GP_Reset_OLD");
      window.hotspot = "multidevice";
      window.scene.groupApplyState('KEYBOARD_GPF01_ON');
      window.scene.groupApplyState('KEYBOARD_REF_BOX_ON');
      window.scene.groupApplyState('ALL_ICONS_ON');
      GotoPosInTimeNamedValue('Render_Cam_F01_Key_Closeup',function () {

         window.localStorage.setItem('hotspot','multidevice');
         window.hotspot = "multidevice";
         bluetoothBlikingLoop();
         clearBluetoothMainInterval.current = setInterval(() => {

            bluetoothBlikingLoop();
            // window.localStorage.setItem('hotspot','keys')
         },6000)
         if (isNextPrevious != true) {
            // alert("isNextPrevious");
            window.document.getElementById("hotspot1demo").focus();
         }
      })
      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");
         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");

      }
      if (position.nintyDegree == position[currentPosName]) { position.currentPos = 'nintyDegree'; return; }
      if (position.currentPos == 'theatre' || position.currentPos == 'tablet') {
         console.log("Theater")
         // window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
         window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD_Keyboard",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
      }
      else {
         console.log("else")
         // window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
         window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD_Keyboard",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
      }

      window.RT_RecordEvent("Product Type","Front",window.config.name);
      window.scene.clearRefine();
      position.currentPos = 'nintyDegree';

   }


   const onCloseClick = (isNextPrevious) => {
      console.log("onCloseClick");
      window.scene._nav._navMinDolly = 13.3;
      window.scene._nav._navMaxDolly = 27;
      window.scene._nav._panMax = [10,5];    //[left, bottom];
      window.scene._nav._panMin = [-15,-10];  //[right, top];
      //Update ZoomBar
      var slider = document.getElementById("sliderRange");
      resetAll();
      firstTime = true;
      window.featuresView = false;
      window.ProductView = true;
      window.keysCam_ultra = true;
      window.scene.groupApplyState("dongle_on");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      console.log(position.nintyDegree,position.currentPos)

      //   var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      //    alreadySelected.classList.remove('active');
      // document.getElementById('frontBtn').classList.add('active');

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('utkeys').classList.add('active');
      window.localStorage.setItem("position","reset");
      window.scene.groupApplyState("screen_180");
      window.scene.groupApplyState("GP_open");
      window.scene.groupApplyState("REF_KB");
      window.scene.groupApplyState("F01_GP_ON");

      window.scene._fDoFFarAperture = 50;


      setSelectedButton('onCloseClick');
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Front view');

         document.getElementById('nextView').setAttribute('aria-label','Front view');
      }



      window.localStorage.removeItem('hotspot');
      window.localStorage.removeItem('currentBluetooth');
      window.scene.animPlayInTime("DE_1662_CA_Trident",0,0);
      window.scene.animPlayInTime("DE_1662_CA_Trident.001",0,0);
      window.scene.clearRefine();
      resetBacklitCloseImg();
      window.localStorage.setItem('hotspot','ultraquiet')
      //window.scene.groupApplyState("GP_All");
      window.scene.groupApplyState("Backlit_OFF");
      window.scene.groupApplyState("keyboard_backlight_off");
      window.scene.groupApplyState("dynamic_reset");
      window.scene.groupApplyState("Dongle_off");
      window.scene.groupApplyState("F01_GP_ON");
      window.scene.groupApplyState('KEYBOARD_GPF01_ON');
      window.scene.groupApplyState('KEYBOARD_REF_BOX_ON');
      window.scene.groupApplyState('ALL_ICONS_ON');
      GotoPosInTimeNamedValue('Render_Cam_F01_Ultra_Zoom_Keys',function () {

         window.scene.groupApplyState("key_off");
         window.scene.groupApplyState("INTERNAL_ON");

         document.getElementById('popupContainer').style.display = "block";
         window.hotspot = 'ultraquiet';


         if (isNextPrevious != true) {
            // alert("isNextPrevious");
            window.document.getElementById("hotspot1demo").focus();
         }
      })
      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");
         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");

      }


      window.RT_RecordEvent("Product Type","Front",window.config.name);
      window.scene.clearRefine();
      position.currentPos = 'nintyDegree';

   }


   const onSideClick = (isNextPrevious) => {
      resetAll();
      reverseAll();
      firstTime = true;
      window.ProductView = true;
      window.featuresView = false;
      //Update ZoomBar
      window.scene._nav._navMinDolly = 13.3;
      window.scene._nav._navMaxDolly = 20;
      // window.scene._nav._navMaxDolly = 15.0; //110 
      window.scene._nav._fovRecoveryOffset = 10;
      console.log('onSideClick',position.nintyDegree,position.currentPos)

      window.UniqDeltaScroll = true;
      setSelectedButton('onSideClick');
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','right view');

         document.getElementById('nextView').setAttribute('aria-label','right view');
      }
      window.localStorage.removeItem('hotspot');
      window.localStorage.removeItem('currentBluetooth');
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('rightBtn').classList.add('active');


      window.localStorage.setItem("position","reset");
      window.scene.groupApplyState("screen_180");
      if (laptop180) {
         window.scene.groupApplyState("screenfill_180");
      } else {
         window.scene.groupApplyState("screenfill_360");
      }
      // window.scene.groupApplyState("GP_open");
      // window.scene.groupApplyState("dynamic_reset");
      // //window.scene.groupApplyState("GP_All");
      window.scene.groupApplyState("REF_KB");
      window.scene.groupApplyState("GP_side");

      window.localStorage.removeItem('hotspot');
      window.localStorage.removeItem('currentBluetooth');
      var slider = document.getElementById("sliderRange");

      resetBacklitCloseImg();
      window.scene.animPlayInTime("DE_1662_CA_Trident",0,0);
      window.scene.animPlayInTime("DE_1662_CA_Trident.001",0,0);
      // window.scene.groupApplyState("Backlit_OFF");
      window.scene.groupApplyState("keyboard_backlight_off");
      window.scene.groupApplyState("F01_GP_ON");
      window.scene.groupApplyState('KEYBOARD_GPF01_ON');
      window.scene.groupApplyState('KEYBOARD_REF_BOX_ON');
      window.scene.groupApplyState("LIGHT_ON");
      window.scene.groupApplyState('ALL_ICONS_ON');
      GotoPosInTimeNamedValue('Render_Cam_F10_L',function () {
         window.scene.animPlayInTime("DE_1662_CA_Trident",0.40,1000);
         window.scene.animPlayInTime("DE_1662_CA_Trident.001",0.4166667,1000);

         window.scene.animPlayInTime("hing1",0.40,1000);
         window.scene.animPlayInTime("hing2",0.4166667,1000);

         window.scene.animPlayInTime("hing1.001",0.40,1000);
         window.scene.animPlayInTime("hing2.001",0.4166667,1000,function () {
            window.localStorage.setItem('hotspot','side');
            window.hotspot = "side";
         });
         window.scene._nav._fovRecoveryOffset = 10;
         // window.scene._nav._fovRecoveryOffset = 15;

         if (slider != null) {
            document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
            setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
         }
         /* setTimeout(function () {
            window.localStorage.setItem('hotspot','side');
            window.hotspot = "side";
         },1200); */

         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }
      });
      // window.document.getElementById("hotspot11").focus();
      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");
         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");

      }
      var currentPosName = position.currentPos;
      if (position.nintyDegree == position[currentPosName]) { position.currentPos = 'nintyDegree'; return; }


      position.currentPos = 'nintyDegree';

      window.RT_RecordEvent("Product Type","Right",window.config.name);
      window.scene.clearRefine();
   }


   var firstTime = true;
   const onOverviewClick = (isNextPrevious) => {
      //Update ZoomBar
      resetAll();
      reverseAll();

      window.scene._nav._navMinDolly = 14;
      window.scene._nav._navMaxDolly = 30;
      window.ProductView = true;
      window.featuresView = false;
      console.log('onOverviewClick',position.nintyDegree,position.currentPos)

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      console.log("left")
      setSelectedButton('onOverviewClick');
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','left view');

         document.getElementById('nextView').setAttribute('aria-label','left view');
      }
      window.localStorage.removeItem('hotspot');
      window.localStorage.removeItem('currentBluetooth');

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }


      document.getElementById('leftBtn').classList.add('active');
      window.localStorage.setItem("position","reset");
      (window.localStorage.getItem("hotspot","right"))
      window.scene.groupApplyState("screen_180");
      if (laptop180) {
         window.scene.groupApplyState("screenfill_180");
      } else {
         window.scene.groupApplyState("screenfill_360");
      }


      window.scene.groupApplyState("keyboard_backlight_off");
      window.scene.groupApplyState("Dongle_on");
      window.scene.groupApplyState("USB_on");
      window.scene.groupApplyState('WAIR_USB_REF_BOX_ON');
      window.scene.groupApplyState('WAIR_USB_GP_ON');
      window.scene.groupApplyState('KEYBOARD_REF_BOX_ON');

      window.scene.groupApplyState("Backlit_OFF");
      window.scene.groupApplyState("dynamic_reset");
      if (firstTime) {
         window.scene.groupApplyState('KEYBOARD_GPF01_ON');
         window.scene.animPlayInTime("DE_1662_CA_Trident",1.0410000,1);
         firstTime = false;
      }
      window.scene.groupApplyState('ALL_ICONS_ON');

      GotoPosInTimeNamedValue('Render_Cam_F20_TF',function () {
         window.scene.groupApplyState('KEYBOARD_GP_OFF');
         window.scene.animPlayInTime("DE_1662_CA_Trident",0.8333333,1000,function () {
            window.hotspot = 'front';
            window.scene.groupApplyState('KEYBOARD_GPF20_ON');
         })
         window.scene.animPlayInTime("DE_1662_CA_Trident.001",0.83333,1000);


         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }


      });
      if (!(window.isipad || window.mob)) {

         document.getElementById("hotspot1").setAttribute("tabindex","1");
         document.getElementById("hotspot2").setAttribute("tabindex","1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");
         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");


      }
      var currentPosName = position.currentPos;
      if (position.nintyDegree == position[currentPosName]) { position.currentPos = 'nintyDegree'; return; }
      if (position.currentPos == 'theatre' || position.currentPos == 'tablet') {
         console.log("Theater")
         // window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
         window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD_Keyboard",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
      }
      else {
         console.log("else")
         // window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
         window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD_Keyboard",position.nintyDegree,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
      }
      position.currentPos = 'nintyDegree';

      window.RT_RecordEvent("Product Type","Left",window.config.name);
      window.scene.clearRefine();
   }
   const onTopClick = (isNextPrevious) => {
      //Update ZoomBar
      console.log('onTopClick',position.top,position.currentPos)
      resetAll();
      reverseAll();
      firstTime = true;
      window.ProductView = true;
      window.featuresView = false;
      window.scene._nav._navMinDolly = 13;
      window.scene._nav._navMaxDolly = 27;
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      window.scene.groupApplyState("F01_GP_ON");
      setSelectedButton('onTopClick');
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Top view');

         document.getElementById('nextView').setAttribute('aria-label','Top view');
      }
      if (laptop180) {
         window.scene.groupApplyState("screenfill_180");
      } else {
         window.scene.groupApplyState("screenfill_360");
      }

      window.localStorage.removeItem('hotspot');
      window.localStorage.removeItem('currentBluetooth');


      //document.getElementById('topBtn').classList.add('active');

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      if (document.getElementById('topBtn')) {
         document.getElementById('topBtn').classList.add('active');
      }


      window.localStorage.setItem("position","reset");
      window.scene.groupApplyState("screen_180");
      if (laptop180) {
         window.scene.groupApplyState("screenfill_180");
      } else {
         window.scene.groupApplyState("screenfill_360");
      }

      window.scene.animPlayInTime("DE_1662_CA_Trident",0,0);
      window.scene.animPlayInTime("DE_1662_CA_Trident.001",0,0);
      resetBacklitCloseImg();

      window.scene.groupApplyState("GP_Reset_OLD");
      window.scene.groupApplyState("keyboard_backlight_off");
      window.scene.groupApplyState('KEYBOARD_GPF01_ON');
      window.scene.groupApplyState('KEYBOARD_REF_BOX_ON');
      window.scene.groupApplyState('ALL_ICONS_ON');
      GotoPosInTimeNamedValue('Render_Cam_F01_Top',function () {

         window.localStorage.setItem('hotspot','top')
         window.hotspot = "top";
         if (isNextPrevious != true) {
            //alert(isNextPrevious);
            window.document.getElementById("hotspot1demo").focus();
         }
      });


      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","1");
         document.getElementById("hotspot4").setAttribute("tabindex","1");
         document.getElementById("hotspot5").setAttribute("tabindex","1");
         document.getElementById("hotspot6").setAttribute("tabindex","1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");
         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");

      }


      var currentPosName = position.currentPos;
      if (position.top == position[currentPosName]) { position.currentPos = 'top'; return; }
      // if (position.currentPos == 'theatre' || position.currentPos == 'tablet') {
      //    console.log("Theater")
      //    window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
      window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD_Keyboard",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
      // }
      // else {
      //    console.log("else")
      //    window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
      window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD_Keyboard",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
      // }

      // position.currentPos = 'top';

      window.RT_RecordEvent("Product Type","Top",window.config.name);
      window.scene.clearRefine();
   }

   //MenuFeatureView

   const [openCloseOnOff,setOpenCloseOnOff] = useState(false);
   // const [backlit,setBacklite] = useState("./img/keyboardbacklight.png");
   const [opneClose,setOpenClose] = useState("./img/zoomkey.png");
   const [backliteOnOff,setBackliteOnOff] = useState(false);


   const [zoomkey,setzoomkey] = useState("./img/zoomkey.png");
   const [backlit,setBacklite] = useState("./img/keyboardbacklight.png");
   const [multidevice,setmultidevice] = useState("./img/multidevice.png");
   const [ultraquiet,setultraquiet] = useState("./img/ultraquiet.png");


   const onZoomKey = (isNextPrevious) => {
      //Update ZoomBar

      console.log('onZoomKey',position.top,position.currentPos)
      resetAll();
      reverseAll();
      firstTime = true;
      window.featuresView = false;
      window.ProductView = true;
      window.zoomCam = true;
      window.scene._nav._navMinDolly = 13.3;
      window.scene._nav._navMaxDolly = 27;
      // window.scene._nav._fovRecoveryOffset = 12;
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      setSelectedButton('onZoomKey');
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Top view');

         document.getElementById('nextView').setAttribute('aria-label','Top view');
      }
      if (laptop180) {
         window.scene.groupApplyState("screenfill_180");
      } else {
         window.scene.groupApplyState("screenfill_360");
      }

      window.localStorage.removeItem('hotspot');
      window.localStorage.removeItem('currentBluetooth');
      window.localStorage.setItem("position","reset");
      window.scene.groupApplyState("screen_180");
      if (laptop180) {
         window.scene.groupApplyState("screenfill_180");
      } else {
         window.scene.groupApplyState("screenfill_360");
      }
      // window.scene.groupApplyState("GP_open");
      // window.scene.groupApplyState("dynamic_reset");

      resetBacklitCloseImg();
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      if (document.getElementById('zoomKeyBtn')) {
         document.getElementById('zoomKeyBtn').classList.add('active');
      }
      window.scene.animPlayInTime("DE_1662_CA_Trident",0,0);
      window.scene.animPlayInTime("DE_1662_CA_Trident.001",0,0);
      window.scene.groupApplyState("keyboard_backlight_off");
      window.scene.groupApplyState("GP_Reset_OLD");
      window.scene.animPlayInTime("Mode_Connection_Button",0.041666,0);
      window.scene.groupApplyState("F01_GP_ON");
      window.scene.groupApplyState('KEYBOARD_GPF01_ON');
      window.scene.groupApplyState('KEYBOARD_REF_BOX_ON');
      window.scene.groupApplyState('ALL_ICONS_OFF');
      GotoPosInTimeNamedValue('Render_Cam_F01_Hotkeys_Closeup',function () {
         window.scene.animPlayInTime("Mode_Connection_Button",0.041666,0);

         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }
         clearTimeOutZoomKeyFifth.current = setTimeout(() => {
            clearTimeout(clearTimeOutZoomKeyFour.current);
            window.scene.groupApplyState('ALL_ICONS_ON');
            window.hotspot = "zoomkey";
            window.scene.clearRefine();

            clearTimeOutZoomKeyOne.current = setTimeout(() => {
               clearTimeout(clearTimeOutZoomKeyFifth.current);
               window.scene.groupApplyState('ALL_ICONS_OFF');
               window.scene.groupApplyState('ICON_1_ON');
               window.hotspot = "video";
               window.scene.clearRefine();
               clearTimeOutZoomKeyTwo.current = setTimeout(() => {
                  clearTimeout(clearTimeOutZoomKeyOne.current);
                  window.scene.groupApplyState('ALL_ICONS_OFF');
                  window.scene.groupApplyState('ICON_2_ON');
                  window.hotspot = "screen";
                  window.scene.clearRefine();
                  clearTimeOutZoomKeyThree.current = setTimeout(() => {
                     clearTimeout(clearTimeOutZoomKeyTwo.current);

                     window.scene.groupApplyState('ALL_ICONS_OFF');
                     window.scene.groupApplyState('ICON_3_ON');
                     window.hotspot = "chat";
                     window.scene.clearRefine();

                     clearTimeOutZoomKeyFour.current = setTimeout(() => {
                        clearTimeout(clearTimeOutZoomKeyThree.current);
                        window.scene.groupApplyState('ALL_ICONS_OFF');
                        window.scene.groupApplyState('ICON_4_ON');
                        window.hotspot = "mute";
                        window.scene.clearRefine();

                     },2500);
                  },2500);
               },2500);
            },3000);
         },500);

      });


      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");
         document.getElementById("hotspot11").setAttribute("tabindex","1");
         document.getElementById("hotspot12").setAttribute("tabindex","1");
         document.getElementById("hotspot13").setAttribute("tabindex","1");

         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");

      }


      var currentPosName = position.currentPos;
      if (position.top == position[currentPosName]) { position.currentPos = 'top'; return; }
      // if (position.currentPos == 'theatre' || position.currentPos == 'tablet') {
      //    console.log("Theater")
      //    window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
      window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD_Keyboard",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
      // }
      // else {
      //    console.log("else")
      //    window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
      window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD_Keyboard",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
      // }

      // position.currentPos = 'top';

      window.RT_RecordEvent("Product Type","Top",window.config.name);
      window.scene.clearRefine();
   }

   const onKeyBacklite = (isNextPrevious) => {
      //Update ZoomBar

      console.log('onKeyBacklite',position.top,position.currentPos)
      resetAll();
      reverseAll();
      window.scene._bDoF = false;
      window.featuresView = true;
      window.ProductView = false;
      window.backlightCam = true;
      window.scene._nav._navMinDolly = 13;
      window.scene._nav._navMaxDolly = 27;
      firstTime = true;
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      setSelectedButton('onKeyBacklite');
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Top view');

         document.getElementById('nextView').setAttribute('aria-label','Top view');
      }
      if (laptop180) {
         window.scene.groupApplyState("screenfill_180");
      } else {
         window.scene.groupApplyState("screenfill_360");
      }

      window.localStorage.removeItem('hotspot');
      window.localStorage.removeItem('currentBluetooth');

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      if (document.getElementById('backlitBtn')) {
         document.getElementById('backlitBtn').classList.add('active');
      }
      // document.getElementById('topBtn').classList.add('active');
      window.localStorage.setItem("position","reset");
      window.scene.groupApplyState("screen_180");
      if (laptop180) {
         window.scene.groupApplyState("screenfill_180");
      } else {
         window.scene.groupApplyState("screenfill_360");
      }
      // window.scene.groupApplyState("GP_open");
      // window.scene.groupApplyState("dynamic_reset");

      resetBacklitCloseImg();
      // reverseAll();
      //window.scene.groupApplyState("GP_All");
      // window.scene.groupApplyState("Backlit_OFF");
      // window.scene.groupApplyState("REF_KB");
      window.scene.animPlayInTime("DE_1662_CA_Trident",0,0);
      window.scene.animPlayInTime("DE_1662_CA_Trident.001",0,0);
      // window.scene.groupApplyState("F01_GP_ON");
      window.scene.groupApplyState('KEYBOARD_GPF01_ON');
      window.scene.groupApplyState('KEYBOARD_REF_BOX_ON');
      window.scene.groupApplyState('ALL_ICONS_ON');
      window.scene.groupApplyState("keyboard_backlight_on");
      GotoPosInTimeNamedValue('Render_Cam_F01_Blacklight_Keyboard',function () {

         // if (window.color === 'laptopBlack') {
         //    console.log('black');            
         //    window.scene.groupApplyState("keyboard_backlight_White_on");
         // } else if (window.color === 'laptopSilver') {
         //    console.log('white');
         //    window.scene.groupApplyState("keyboard_backlight_on");
         // }
         // window.localStorage.setItem('hotspot','top')
         window.hotspot = "backlight"

         if (isNextPrevious != true) {
            //alert(isNextPrevious);
            window.document.getElementById("hotspot1demo").focus();
         }
      });


      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","1");
         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("hotspot12").setAttribute("tabindex","-1");

         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");

      }


      var currentPosName = position.currentPos;
      if (position.top == position[currentPosName]) { position.currentPos = 'top'; return; }
      // if (position.currentPos == 'theatre' || position.currentPos == 'tablet') {
      //    console.log("Theater")
      //    window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
      window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD_Keyboard",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
      // }
      // else {
      //    console.log("else")
      //    window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
      window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD_Keyboard",position.top,animTime,undefined,undefined,undefined,true,position[currentPosName],0);
      // }

      // position.currentPos = 'top';

      window.RT_RecordEvent("Product Type","Top",window.config.name);
      window.scene.clearRefine();
   }



   //menucolor

   const color1Click = () => {
      //   var alreadySelecte = document.querySelector('.MuiAccordionDetails-root.select');
      // alreadySelecte.classList.remove('select');

      var alreadySelecte = document.querySelector('.MuiAccordionDetails-root.select');
      if (alreadySelecte != null) {
         alreadySelecte.classList.remove('select');
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      // document.getElementById('whiteBtn').classList.add('select');
      // document.getElementById('whiteBtn').classList.add('active');
      if (document.getElementById('whiteBtn')) {
         document.getElementById('whiteBtn').classList.add('select');
         document.getElementById('whiteBtn').classList.add('active');
      }
      if (document.getElementById('blackBtn')) {
         document.getElementById('blackBtn').classList.remove('active','select');
      }

      window.localStorage.setItem("position","reset");

      setOpenCloseOnOff(false);
      setOpenClose("./img/zoomkey.png");
      setBackliteOnOff(false);
      setBacklite("./img/keyboardbacklight.png");
      setLaptop360FrontImg("./img/front180White.png");
      setLaptop360TopImg("./img/top180White.png");
      setLaptop360LefttImg("./img/180_white_left.png");
      setLaptop360RightImg("./img/180_white_right.png");

      setZoomImg("./img/zoomkey.png");
      setBacklitImg("./img/keyboardbacklight.png");
      setKeysImg("./img/multidevice.png");
      setUltraImg("./img/ultraquiet.png");
      setLaptop360LefttImg("./img/overview.png");
      setLaptop360TopImg("./img/top.png");
      setLaptop360RightImg("./img/side.png");
      setLaptop360FrontImg("./img/back.png");


      window.scene.groupApplyState("screenfill_180");
      window.localStorage.setItem("color","laptopSilver");
      setPort4Click(false);
      window.scene.groupApplyState("keyboard_Graphite_Color_ON");

      window.localStorage.setItem("silver",true);
      window.RT_RecordEvent("Color","Aluminium",window.config.name);
      window.scene.clearRefine();



   }

   const color2Click = () => {

      console.log("color2");
      window.localStorage.setItem("position","reset");
      window.localStorage.setItem("color","laptopBlack");
      window.localStorage.removeItem('closeMode')


      setOpenCloseOnOff(false);
      setOpenClose("./img/zoomkey.png");
      setBackliteOnOff(false);
      setBacklite("./img/keyboardbacklight.png");
      setLaptop360FrontImg("./img/front180Black.png");
      setLaptop360TopImg("./img/top180Black.png");
      setLaptop360LefttImg("./img/180_black_left.png");
      setLaptop360RightImg("./img/180_black_right.png");
      window.scene.groupApplyState("screenfill_180");
      setPort2Click(false);
      setPort1Click(false);
      setPort3Click(false);
      setPort4Click(false);

      setZoomImg("./img/Pzoomkey.png");
      setBacklitImg("./img/Pkeyboardbacklight.png");
      setKeysImg("./img/Pmultidevice.png");
      setUltraImg("./img/Pultraquiet.png");
      setLaptop360LefttImg("./img/Poverview.png");
      setLaptop360TopImg("./img/Ptop.png");
      setLaptop360RightImg("./img/Pside.png");
      setLaptop360FrontImg("./img/Pback.png");

      window.localStorage.setItem("Carbon_Fibre",true);
      window.scene.groupApplyState("keyboard_Platinum_Color_ON");



      if (window.localStorage.getItem('laptop') == 'laptop360') {
         // console.log('a')
         //         var alreadySelecte = document.querySelector('.MuiAccordionDetails-root.select');
         // alreadySelecte.classList.remove('select');

         var alreadySelecte = document.querySelector('.MuiAccordionDetails-root.select');
         if (alreadySelecte != null) {
            alreadySelecte.classList.remove('select');
         }

         var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
         if (alreadySelected != null) {
            alreadySelected.classList.remove('active');
         }
         if (document.getElementById('blackBtn')) {
            document.getElementById('blackBtn').classList.add('select');
            document.getElementById('blackBtn').classList.add('active');
         }
         if (document.getElementById('whiteBtn')) {

            document.getElementById('whiteBtn').classList.remove('active','select');
         }
         window.scene.groupApplyState("Silver");

      }
      else if (window.localStorage.getItem('laptop') == 'laptop180') {
         // console.log('b')
         //         var alreadySelecte = document.querySelector('.MuiAccordionDetails-root.select');
         // alreadySelecte.classList.remove('select');

         var alreadySelecte = document.querySelector('.MuiAccordionDetails-root.select');
         if (alreadySelecte != null) {
            alreadySelecte.classList.remove('select');
         }

         var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
         if (alreadySelected != null) {
            alreadySelected.classList.remove('active');
         }
         if (document.getElementById('blackBtn')) {
            document.getElementById('blackBtn').classList.add('select');
            document.getElementById('blackBtn').classList.add('active');
         }
         if (document.getElementById('whiteBtn')) {

            document.getElementById('whiteBtn').classList.remove('active','select');
         }
         // document.getElementById('blackBtn').classList.add('select');
         // document.getElementById('blackBtn').classList.add('active');
         window.scene.groupApplyState("Carbon_Black");
         window.scene.groupApplyState("screenfill_180");

      }
      window.RT_RecordEvent("Color","Carbon Fiber",window.config.name);
      window.scene.clearRefine();
   }
   //Menu Position

   const [port1Click,setPort1Click] = useState(false);
   const [port2Click,setPort2Click] = useState(false);
   const [port3Click,setPort3Click] = useState(false);
   const [port4Click,setPort4Click] = useState(false);
   const [port5Click,setPort5Click] = useState(true);

   const [nextClick,setNextClick] = useState(false);
   const [prevClick,setPrevClick] = useState(false);

   const TentModeClick = () => {
      console.log(position.tent,position.currentPos)

      //Update ZoomBar
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('tentBtn').classList.add('active');
      window.scene.groupApplyState("screen_360");
      setSelectedButton('TentModeClick');
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Tent Mode');

         document.getElementById('nextView').setAttribute('aria-label','Tent Mode');
      }
      setOpenCloseOnOff(false);
      setOpenClose("./img/zoomkey.png");
      setBackliteOnOff(false);
      setBacklite("./img/keyboardbacklight.png");
      window.localStorage.removeItem('hotspot');
      window.localStorage.removeItem('currentBluetooth');
      GotoPosInTimeNamedValue('Tent_Cam_F53_Tent',function () {
         window.scene.groupApplyState("GP_tent");
      });

      var currentPosName = position.currentPos;
      if (position.tent == position[currentPosName]) { position.currentPos = 'tent'; return; }
      window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD",position.tent,animTime,undefined,undefined,undefined,true,position[currentPosName],4);
      window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD_Keyboard",position.tent,animTime,undefined,undefined,undefined,true,position[currentPosName],4);

      window.RT_RecordEvent("Positions","Tent",window.config.name);
      window.scene.clearRefine();
      position.currentPos = 'tent';

   }

   const TheaterModeClick = () => {
      console.log(position.theatre,position.currentPos)

      //Update ZoomBar
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('theaterBtn').classList.add('active');
      window.scene.groupApplyState("screen_180");

      window.localStorage.removeItem('closeMode')
      setSelectedButton('TheaterModeClick');
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Theater Mode');

         document.getElementById('nextView').setAttribute('aria-label','Theater Mode');
      }
      window.scene.groupApplyState("Backlit_OFF");
      window.scene.groupApplyState("all_GP_off");
      setOpenCloseOnOff(false);
      setOpenClose("./img/zoomkey.png");
      setBackliteOnOff(false);
      setBacklite("./img/keyboardbacklight.png");

      window.localStorage.removeItem('hotspot');
      window.localStorage.removeItem('currentBluetooth');
      GotoPosInTimeNamedValue('Render_Cam_F100_Stand');

      var currentPosName = position.currentPos;
      if (position.theatre == position[currentPosName]) { position.currentPos = 'theatre'; return; }
      window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD",position.theatre,animTime,undefined,undefined,undefined,true,position[currentPosName],9);
      window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD_Keyboard",position.theatre,animTime,undefined,undefined,undefined,true,position[currentPosName],4);

      window.RT_RecordEvent("Positions","Theatre",window.config.name);
      window.scene.clearRefine();
      position.currentPos = 'theatre';

   }
   const TabletModeClick = () => {
      console.log(position.tent,position.currentPos)

      //Update ZoomBar
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }


      document.getElementById('tabletBtn').classList.add('active');
      window.scene.groupApplyState("screen_180");
      window.scene.groupApplyState("all_GP_off");
      setSelectedButton('TabletModeClick');
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Tablet Mode');

         document.getElementById('nextView').setAttribute('aria-label','Tablet Mode');
      }
      window.scene.groupApplyState("Backlit_OFF");
      setOpenCloseOnOff(false);
      setOpenClose("./img/zoomkey.png");
      setBackliteOnOff(false);
      setBacklite("./img/keyboardbacklight.png");

      window.localStorage.removeItem('hotspot');
      window.localStorage.removeItem('currentBluetooth');
      GotoPosInTimeNamedValue('Close_Cam_F158_Close1');

      var currentPosName = position.currentPos;
      if (position.tablet == position[currentPosName]) { position.currentPos = 'tablet'; return; }
      window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD",position.tablet,animTime,undefined,undefined,undefined,true,position[currentPosName],10);
      window.scene.animPlayAllChildrenInTime("CA_Wireless_KB_MPD_Keyboard",position.tablet,animTime,undefined,undefined,undefined,true,position[currentPosName],10);

      window.RT_RecordEvent("Positions","Tablet",window.config.name);
      window.scene.clearRefine();
      position.currentPos = 'tablet';
   }
   const resetMode = () => {
      setSelectedButton('onResetMode');
      GotoPosInTimeNamedValue('Render_Cam_F20_TF',function () { })
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Reset Mode');

         document.getElementById('nextView').setAttribute('aria-label','Reset Mode');
      }
   }
   const onResetMode = () => {
      //Update ZoomBar
      console.log(position.tent,position.currentPos);


      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         slider.value = window.scene._nav.getZoomFactor();
         setTimeout(function () { slider.value = window.scene._nav.getZoomFactor(); },1000);
      }

      window.color = '';
      if (selectedButton == 'TentModeClick') {
         TentModeClick();
      }
      else if (selectedButton == 'TheaterModeClick') {
         TheaterModeClick();

      }
      else if (selectedButton == 'TabletModeClick') {
         TabletModeClick();
      }
      else if (selectedButton == 'onOverviewClick') {
         console.log(" onOverviewClick reset");
         onOverviewClick();
      }
      else if (selectedButton == 'onTopClick') {
         console.log("top onreset");
         onTopClick();
      }
      else if (selectedButton == 'onSideClick') {
         console.log("side onreset");
         onSideClick();
      }
      else if (selectedButton == 'onBackClick') {
         console.log("back onreset");
         onBackClick();
      }
      else if (selectedButton == 'onZoomKey') {
         console.log("onZoomKey");
         onZoomKey();
      }
      else if (selectedButton == 'onKeyBacklite') {
         console.log("onKeyBacklite");
         onKeyBacklite();
      }
      else if (selectedButton == 'onKeysClick') {
         console.log("onKeysClick");
         onKeysClick();
      }
      else if (selectedButton == 'onCloseClick') {
         console.log("onCloseClick");
         onCloseClick();
      }
      else if (selectedButton == 'openCloseClick') {
         if (openCloseOnOff) {
            // setOpenCloseOnOff(false);
            //   setOpenClose("./img/zoomkey.png");
            //   window.scene.groupApplyState("dynamic_reset");

            GotoPosInTimeNamedValue('Close_Cam_F158_Close',function () {

            });


         } else {
            // setOpenCloseOnOff(true);
            //   setOpenClose("./img/Lid_close.svg");
            // window.scene.groupApplyState("dynamic_reset");
            GotoPosInTimeNamedValue('Render_Cam_F01_FL',function () {

            });
         }

      }
      else if (selectedButton == 'backliteClick') {

         GotoPosInTimeNamedValue('Render_Cam_F198_Top',function () {
         })
         // window.scene.groupApplyState("Backlit_ON");
         window.scene.clearRefine();

         // }


      } else if (selectedButton == 'onResetMode') {
         resetMode()
      }

      if (window.color === 'laptopBlack') {
         window.scene.groupApplyState("Carbon_Fibre_180A");
         window.scene.groupApplyState("Screen_Fill_180_ON");
      } else if (window.color === 'laptopSilver') {
         window.scene.groupApplyState("Silver");
         window.scene.groupApplyState("Screen_Fill_180_Silver_ON");
      }

      window.scene.clearRefine();
   }

   const onPreviousMode = () => {

      //Update ZoomBar
      let slider = document.getElementById("sliderRange");

      if (slider) {
         slider.value = window.scene._nav.getZoomFactor();
         setTimeout(() => slider.value = window.scene._nav.getZoomFactor(),1000);
      }

      let prevButton;

      let selectedButtonIndex = buttonSeq.findIndex(element => element == selectedButton)
      if (selectedButton === 'onOverviewClick' || selectedButton === 'onResetMode') {
         prevButton = 'onCloseClick';
      } else {
         prevButton = buttonSeq[selectedButtonIndex - 1];
         console.log(selectedButtonIndex - 1);

      }
      // console.log(selectedButtonIndex);
      // console.log(prevButton);
      if (prevButton == 'onCloseClick') {
         onCloseClick(true);
         setExpandedPanel("panel3");
      }
      else if (prevButton == 'onKeysClick') {
         onKeysClick(true);
         setExpandedPanel("panel3");
      }
      else if (prevButton == 'onKeyBacklite') {
         setExpandedPanel("panel3");
         onKeyBacklite(true);
      }
      else if (prevButton == 'onZoomKey') {
         setExpandedPanel("panel3");
         onZoomKey(true);
      }
      else if (prevButton == 'onBackClick') {
         onBackClick(true);
         setExpandedPanel("panel1");
      }
      else if (prevButton == 'onSideClick') {

         setExpandedPanel("panel1");
         onSideClick(true);
      }
      else if (prevButton == 'onTopClick') {

         setExpandedPanel("panel1");
         onTopClick(true);
      }
      else if (prevButton == 'onOverviewClick') {
         onOverviewClick(true);
         setExpandedPanel("panel1");
      }

   }
   const onNextMode = () => {



      //Update ZoomBar
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         slider.value = window.scene._nav.getZoomFactor();
         setTimeout(function () { slider.value = window.scene._nav.getZoomFactor(); },1000);
      }
      if (laptop180) {

         var nextButton;
         var selectedButtonIndex = buttonSeq180.findIndex(element => element === selectedButton)
         console.log(selectedButtonIndex);
         if (selectedButton == 'onCloseClick') {
            nextButton = 'onOverviewClick';
         } else {
            nextButton = buttonSeq180[selectedButtonIndex + 1];
         }

      }
      else {
         var nextButton;
         var selectedButtonIndex = buttonSeq.findIndex(element => element === selectedButton);
         console.log(selectedButtonIndex);
         if (selectedButton == 'onCloseClick') {
            nextButton = 'onOverviewClick';
         } else {
            nextButton = buttonSeq[selectedButtonIndex + 1];
         }

      }

      if (nextButton == 'onOverviewClick') {
         onOverviewClick(true);
         setExpandedPanel("panel1");
      }
      else if (nextButton == 'onTopClick') {
         setExpandedPanel("panel1");
         onTopClick(true);
      }
      else if (nextButton == 'onSideClick') {
         setExpandedPanel("panel1");
         onSideClick(true);
      }
      else if (nextButton == 'onBackClick') {
         onBackClick(true);
         setExpandedPanel("panel1");
      }
      else if (nextButton == 'onZoomKey') {
         setExpandedPanel("panel3");
         onZoomKey(true);
      }
      else if (nextButton == 'onKeyBacklite') {
         setExpandedPanel("panel3");
         onKeyBacklite(true);
      }
      else if (nextButton == 'onKeysClick') {
         setExpandedPanel("panel3");
         onKeysClick(true);
      }
      else if (nextButton == 'onCloseClick') {
         onCloseClick(true);
         setExpandedPanel("panel3");
      }

   }


   const [animValue,setAnimValue] = useState("On");
   const [animValue1,setAnimValue1] = useState("On");
   // window.localStorage.setItem('Animation', 'on');

   // useEffect(() => {
   //    // alert();
   //    document.getElementById("animSwitchValue").setAttribute('aria-label','Animation On')
   //    // document.getElementById('animSwitchValue').setAttribute('aria-label','clickable checkbox checked On');
   //    document.getElementById("animSwitchValue").checked = true;

   //    setAnimValue("On");
   //    window.localStorage.setItem('Animation','on');
   //    document.getElementsByClassName('onOff')[0].style.left = "-17px";
   //    window.animationSwitchVal = 'on';



   //    document.getElementById("animSwitchValue1").setAttribute('aria-label','Animation On')
   //    // document.getElementById('animSwitchValue1').setAttribute('aria-label','clickable checkbox checked On');
   //    document.getElementById("animSwitchValue1").checked = true;

   //    setAnimValue("On");
   //    window.localStorage.setItem('Animation','on');
   //    document.getElementsByClassName('onOff1')[0].style.left = "-17px";

   // },[]);

   useEffect(() => {
      window.localStorage.setItem('Animation','on');
      document.getElementById("animSwitchValue").checked = 'true';

      setAnimValue("On");
      document.getElementsByClassName('onOff')[0].style.left = "-17px";
      if (document.getElementById("animSwitchValue1") !== null) {
         document.getElementById("animSwitchValue1").checked = 'true';
      }
      setAnimValue1("On");
      if (!(mob || isipad)) {
         window.localStorage.setItem('Animation1','on');
         document.getElementsByClassName('onOff1')[0].style.left = "-17px";

      }
      return () => {
         return false
      }
   },[]);

   const setAnimationSwitch = (e) => {
      console.log(e)
      // displayName(e);
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked == true) {
         document.getElementById("animSwitchValue").setAttribute('aria-label','Animation Off');
         document.getElementById("animSwitchValue").checked = false;
         setAnimValue("Off");
         document.getElementsByClassName('onOff')[0].style.left = "9px";
         window.localStorage.setItem('Animation','off');
         window.animationSwitchVal = 'off';

         window.RT_RecordEvent("Animations","Off",window.config.name);
         //   document.getElementById('animSwitchValue').setAttribute('aria-label', '');
         // document.getElementById('animSwitchValue').innerHTML = 'clickable checkbox checked On';
         // alert("Animation On");

      } else {
         document.getElementById("animSwitchValue").setAttribute('aria-label','Animation On')
         document.getElementById("animSwitchValue").checked = true;
         window.animationSwitchVal = 'on';
         setAnimValue("On");
         window.localStorage.setItem('Animation','on');
         document.getElementsByClassName('onOff')[0].style.left = "-17px";

         window.RT_RecordEvent("Animations","On",window.config.name);
         // alert("Animation Off");
         //   document.getElementById('animSwitchValue').setAttribute('aria-label', '');
         // document.getElementById('animSwitchValue').innerHTML = 'clickable checkbox checked Off';
      }
   }

   const displayName = (e) => {
      console.log(e)
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked == true) {
         setAnimValue("On");
         window.localStorage.setItem('Animation','on');
         document.getElementsByClassName('onOff')[0].style.left = "-17px";
         document.getElementById('animSwitchValue').setAttribute('aria-label','');
         document.getElementById('animSwitchValue').innerHTML = 'clickable checkbox checked On';
         window.animationSwitchVal = 'off';
         // document.getElementById('animSwitchValue').setAttribute('aria-label','clickable checkbox checked On');
         // alert("Animation On");

      } else {
         setAnimValue("Off");
         document.getElementsByClassName('onOff')[0].style.left = "9px";
         window.localStorage.setItem('Animation','off');
         document.getElementById('animSwitchValue').setAttribute('aria-label','');
         document.getElementById('animSwitchValue').innerHTML = 'clickable checkbox checked Off';
         window.animationSwitchVal = 'on';
         // document.getElementById('animSwitchValue').setAttribute('aria-label','clickable checkbox checked Off');
         // alert("Animation Off");

      }

   }

   const keyboardOff = () => {
      console.log('Keyboard off');
      document.onkeydown = function (e) {
         if (e.keyCode == 13 || e.keyCode == 32)
            setExpandedPanel(false)
         e.preventDefault();
         return false;
      };
   }
   const keyboardOn = () => {
      console.log('Keyboard on');
      document.onkeydown = function (e) {
         return true;
      }
   }


   const setAnimationSwitch1 = (e) => {
      console.log(e)
      // displayName(e);
      const isChecked = document.getElementById("animSwitchValue1").checked;

      if (isChecked == true) {
         //document.getElementById("animSwitchValue").setAttribute('aria-label', 'Animation Off');
         document.getElementById("animSwitchValue1").checked = false;
         setAnimValue1("Off");
         // keyboardOff();
         document.getElementsByClassName('onOff1')[0].style.left = "9px";
         // window.localStorage.setItem('Animation1','off');
         window.animationSwitchVal = 'off';
         window.animationSwitchGlobal = 'off';


      } else {
         // document.getElementById("animSwitchValue").setAttribute('aria-label', 'Animation On')
         document.getElementById("animSwitchValue1").checked = true;

         setAnimValue1("On");
         window.animationSwitchVal = 'on';
         // keyboardOn();
         // window.localStorage.setItem('Animation1','on');
         window.animationSwitchGlobal = 'on';
         document.getElementsByClassName('onOff1')[0].style.left = "-17px";




      }
   }
   var animStopped = true;

   const displayName1 = (e) => {
      if (animStopped == false) {
         return;
         animStopped = false;
      }
      console.log(e)
      const isChecked = document.getElementById("animSwitchValue1").checked;

      if (isChecked == true) {
         setAnimValue1("On");
         // keyboardOn();
         // window.localStorage.setItem('Animation1','on');
         window.animation1SwitchGlobal = 'on';
         document.getElementsByClassName('onOff1')[0].style.left = "-17px";
         document.getElementById('animSwitchValue1').setAttribute('aria-label','clickable checkbox checked On');
         window.animationSwitchVal = 'on';

         if (mob) {
            document.getElementById('footerControls').removeAttribute('style');
            document.getElementById('footerControMob').style.display = 'block';
         }
         else if (isipad) {
            console.log('portrait');
            document.getElementById('footerControMob').style.display = 'block';
            document.getElementById('footerControls').style.display = 'block';
         }
         else {
            console.log("show");

            document.getElementById('footerControls').style.transition = "bottom 0.2s linear";
            document.getElementById('footerControls').style.bottom = "20px";
            document.getElementById('footerControMob').style.transition = "bottom 0.2s linear";
            document.getElementById('footerControMob').style.bottom = "20px";
            //  document.getElementById('footerControIpad').style.transition = "bottom 0.2s linear";
            //  document.getElementById('footerControIpad').style.bottom = "20px";

            document.getElementById('footerControls').style.visibility = "";
            document.getElementById('footerControIpad').style.visibility = "";
            document.getElementById('footerControMob').style.visibility = "";

         }


      } else {
         setAnimValue1("Off");
         // keyboardOff();
         document.getElementsByClassName('onOff1')[0].style.left = "9px";
         // window.localStorage.setItem('Animation1','off');
         window.animation1SwitchGlobal = 'off';

         document.getElementById('animSwitchValue1').setAttribute('aria-label','clickable checkbox checked Off');

         if (mob) {
            document.getElementById('footerControls').removeAttribute('style');
            document.getElementById('footerControMob').style.display = 'none';
         } else if (isipad) {
            console.log('landscape');
            document.getElementById('footerControMob').style.display = 'none';
            document.getElementById('footerControls').style.display = 'none';
         }
         else {
            console.log("hide");
            //document.getElementById('footerControls').style.transition = "bottom 0.2s linear";
            document.getElementById('footerControls').style.bottom = "-112px";
            //   document.getElementById('footerControMob').style.transition = "bottom 0.24s linear";
            document.getElementById('footerControMob').style.bottom = "-112px";
            //  document.getElementById('footerControIpad').style.bottom = "-112px"; 

            setTimeout(function () {

               document.getElementById('footerControls').style.visibility = "hidden";
               document.getElementById('footerControIpad').style.visibility = "hidden";

               document.getElementById('footerControMob').style.visibility = "hidden";

               animStopped = true;
            },150);
         }

      }

   }


   return (
      <>
         {/* <Hidden only={["xs",'sm']}> */}
         {!mob && <HowToUse />}
         {/* </Hidden> */}
         <Hidden only={['sm','md','lg','xl']}>

            <Button style={{ position: 'fixed',backgroundColor: '#F0F0F0',width: '100%',height: '56px',paddingTop: '15px',paddingBottom: '15px',zIndex: '1',border: '1px solid #E1E1E1',borderLeft: "none",borderRight: "none",borderRadius: "0",margin: "-1px 0px 0px 0px" }}
               variant="outlined"
               color="primary"
               // className={classes.button}
               endIcon={<img src="./img/cross.svg" alt="cross" style={{ marginLeft: '207px',height: '23px' }} />}
               onClick={props.toggleDrawerAction}
            >
               {window.finalLangues.mainMenu}
            </Button>
            <Howtousenew />

         </Hidden >
         <Hidden only={['md','lg','xl','xs']}>
            {moblandscap && <Howtousenew />}
         </Hidden>

         <Hidden only={["xs"]}>
            <FooterControl name="reset and next previous" onReset={onResetMode} onPrevious={onPreviousMode} onNext={onNextMode} />
         </Hidden>
         <Hidden only={['lg','xl']}>
            <FooterControlMob onResetMob={onResetMode} onPreviousMob={onPreviousMode} onNextMob={onNextMode} onResetIpad={onResetMode} onNextIpad={onNextMode} onPreviousIpad={onPreviousMode} />
         </Hidden>
         {/* <MenuSelectProductType tabIndex="1" name={window.finalLangues.selectproduct_text} onclicked={laptopClick} onclickedtwo={select2in1Click} value={value} expanded={expandedPanel === 'panel5'} onChanged={handleAccordionChange('panel5')} /> */}
         {/* <userContext.Provider value=""> */}
         {/* <MenuColors name={window.finalLangues.colors} tabIndex="1" onWhiteBtnClick={color1Click} onBlackBtnClick={color2Click} expanded={expandedPanel === 'panel4'} onChanged={handleAccordionChange('panel4')} /> */}
         {/* </userContext.Provider> */}
         {/* <MenuPositions name={window.finalLangues.position} tabIndex="1" onTentMode={TentModeClick} onTheaterMode={TheaterModeClick} onTabletMode={TabletModeClick} expanded={expandedPanel === 'panel2'} onChanged={handleAccordionChange('panel2')} /> */}
         <MenuProductView tabIndex="1" onWirelessDesignBtnClick={onBackClick} onWorkspaceBtnClick={onCloseClick} onTopBtnClick={onTopClick} onLeftBtnClick={onOverviewClick} onRightBtnClick={onSideClick} imgfront={laptop360FrontImg} imgKeys={laptop360KeysImg} imgtop={laptop360TopImg} imgleft={laptop360LeftImg} imgright={laptop360RightImg} imgeco={ecoImg} name={window.finalLangues.productview} expanded={expandedPanel === 'panel1'} onChanged={handleAccordionChange('panel1')} />

         <MenuFeatures name={window.finalLangues.feature} tabIndex="1" tobechange={opneClose} tobeChangedUltra={ultraImg} tobeChangedKeys={keysImg} tobeChangedBacklit={backlitImg} tobeChangeZoom={zoomImg} onZoomKey={onZoomKey} onKeyBacklite={onKeyBacklite} onKeysBtnClick={onKeysClick} onCloseBtnClick={onCloseClick} expanded={expandedPanel === 'panel3'} onChanged={handleAccordionChange('panel3')} />

         {/* <AnimationBtn onchange={displayName} forKeypress={setAnimationSwitch} value={animValue} /> */}
         <AnimationBtn onchange={displayName} forKeypress={setAnimationSwitch} value={animValue} onchange1={displayName1} forKeypress1={setAnimationSwitch1} value1={animValue1} />

      </>
   );
}

export default MainMenu;